/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from 'react-toastify';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import { Routing } from 'shared/constants/routing';
import { IAuthState, IGeneralState } from './auth-state';

/**
 * General state
 */
export interface IApplicationState {
    UserData: IAuthState;
    GeneralData: IGeneralState;
}

/**
 * General action
 */
export interface IAction<T = unknown> {
    type: string | number;
    payload?: T;
}

export const isUserAuthenticated = connectedRouterRedirect({
    redirectPath: (state: IApplicationState) => {
        if (!state.UserData || !state.UserData.authConfigs || !state.UserData.authConfigs.accessToken) toast.dismiss();
        if (state.UserData != null && state.UserData.forceRedirection != null) {
            return state.UserData.forceRedirection;
        }
        return Routing.LogIn;
    },
    allowRedirectBack: true,
    authenticatedSelector: (state: IApplicationState) => {
        if (
            state.UserData != null &&
            state.UserData.authConfigs != null &&
            state.UserData.authConfigs.accessToken != null &&
            state.UserData.authConfigs.accessToken != '' &&
            (state.UserData.forceRedirection == null || window.location.pathname === state.UserData.forceRedirection)
        ) {
            return true;
        }
        return false;
    },
    wrapperDisplayName: 'Authenticated',
}) as any;

export const isAuthenticated = connectedRouterRedirect({
    redirectPath: Routing.LogIn,
    allowRedirectBack: false,
    authenticatedSelector: (state: IApplicationState) => {
        if (
            state.UserData != null &&
            state.UserData.authConfigs != null &&
            state.UserData.authConfigs.accessToken != null &&
            state.UserData.authConfigs.accessToken != ''
        ) {
            return true;
        }
        return false;
    },
    wrapperDisplayName: 'Authenticated',
}) as any;

export const isNotAuthenticated = connectedRouterRedirect({
    redirectPath: Routing.TimeLine,
    allowRedirectBack: false,
    authenticatedSelector: (state: IApplicationState) => {
        if (
            state.UserData == null ||
            state.UserData.authConfigs === null ||
            state.UserData.authConfigs.accessToken === null ||
            state.UserData.authConfigs.accessToken === ''
        ) {
            return true;
        }
        return false;
    },
    wrapperDisplayName: 'IsNotAuthenticated',
}) as any;
